import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MapService } from '../../../../../../../shared/services/map.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  ScrollService
} from '../../../../../../../shared/services/scroll.service';

@Component({
    selector: 'app-wrapper',
    templateUrl: './wrapper.component.html',
    styleUrls: ['../../styles.css', './wrapper.component.scss'],
    standalone: false
})
export class MapSidenavLaborEquipmentWrapperComponent implements OnInit,
                                                                 OnDestroy {
  private readonly onDestroy: Subject<any> = new Subject<any>();
  @Input() data: any;

  isLaborSectionExpanded = false;
  isEquipmentSectionExpanded = false;

  constructor(
    private mapService: MapService,
    private scrollService: ScrollService
  ) {
  }

  ngOnInit() {
    this.mapService.selectedMarkerData
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (data.labor) {
          this.isLaborSectionExpanded = true;
          this.isEquipmentSectionExpanded = false;
        }

        if (data.equipment) {
          this.isLaborSectionExpanded = false;
          this.isEquipmentSectionExpanded = true;
        }

        setTimeout(() => {
          this.scrollService.scrollToElementById(data.id.trim());
        }, 200);
      });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
